/* ========================================================================= */
/* Location */
/* ========================================================================= */

let LOCATION = {};

/**
 * Set global variable LOCATION
 * @param {string} d Site's location
 */
export const setLocation = (d) => {
    LOCATION = new URL(d);
};

/**
 * Get global variable LOCATION
 * @return {URL}
 */
export const getLocation = () => {
    // new URL or something
    return LOCATION;
};
